export default {
  getDiscount: state =>  {
    return state.discounts
  },
  getGeneralDiscount: state =>  {
    return state.generalDiscount
  },
  getMaxDiscount: state =>  {
    return state.maxDiscount
  }
}